
export const PicClicked = {
    methods: {
        picClicked: function(ref) {
            this[ref + 'Visible'] = true;
            this.$refs[ref].scrollIntoView().fade();
        }
    }
};
